module.exports = __webpack_public_path__ + "img/2_of_Clubs.svg.4a40a1f2.png";